<template>
    <a-card class="mb-3">
        <template slot="title">
            <b class="mr-3">需回避单位</b>
          <a-button type="primary" icon="plus-circle" @click="onAddAvoidUnitExpert" ghost>
            新增
          </a-button>
        </template>

        <a-form-model ref="avoidExpertUnitFormRef" :model="avoidExpertUnitForm" class="exi_form item_100"  :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
            <!--新增单位-->
            <div class="model-expert" v-if="avoidExpertUnitForm.data.length > 0">
                <a-row v-for="(item,index) in avoidExpertUnitForm.data" :gutter="20" type="flex" align="middle">
                    <a-col :span="7">
                        <a-form-model-item label="单位名称"
                                           :rules="{required: true, whitespace: true, message: '请输入单位名称', trigger: 'change'}"
                                           :prop="'data.'+index+'.unitName'">
                            <a-input placeholder="单位名称"
                                     v-model.trim="item.unitName"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="7">
                        <a-form-model-item label="统一信用代码"
                                           :prop="'data.'+index+'.creditCode'">
                            <a-input placeholder="统一信用代码"
                                     v-model.trim="item.creditCode"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="7">
                        <a-button @click="delAvoidUnitExpert(item.id)" type="danger" ghost>
                            移除
                        </a-button>
                    </a-col>
                </a-row>
            </div>
          <div v-else>
            暂无数据，点击新增回避单位
          </div>
        </a-form-model>

    </a-card>
</template>
<script>
  import { PageView } from '@/layouts'
  import { Empty } from 'ant-design-vue'

  const uuidv4 = require('uuid/v4')

  export default {
    name: 'AvoidExpertUnitForm',
    beforeCreate () {
      this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
    },
    props: {
      avoidExpertUnitForm: {
        type: Object,
        default () {
          return {
            data: [],
          }
        }
      }
    },
    components: {
      PageView,
    },
    data () {
      return {}
    },
    computed: {},
    created () {
    },
    methods: {
      onAddAvoidUnitExpert () {
        const data = {
          id: uuidv4(),
          applyId: this.applyId,
          unitName: '',
          creditCode: '',
          unitType: '5'
        }
        this.avoidExpertUnitForm.data.push(data)
      },
      delAvoidUnitExpert (id) {
        const newData = this.avoidExpertUnitForm.data.filter(item => item.id !== id)
        this.avoidExpertUnitForm.data = [...newData]
      },

    }
  }

</script>

<style scoped lang="less">

</style>
